export enum DataSource {
  STRUCTURES = "structures",
  AREAS = "areas",
}

export enum ContentType {
  CSV = "text/csv",
  XLS = "application/vnd.ms-excel",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}

export interface DownloadDataConfig {
  companyId: string;
  structureId: string;
  contentType: ContentType;
  dataSource: DataSource;
  template?: boolean;
}